import { Component, Vue } from 'vue-property-decorator';
import AppBodyVue from './body/AppBody.vue';
import AppFooterVue from './footer/AppFooter.vue';
import AppHeaderVue from './header/AppHeader.vue';
import AppMenuVue from './menu/AppMenu.vue';
import AppBusyOverlayComponentVue from '@/components/busy/AppBusyOverlayComponent.vue';
import { tjipBusyService } from '@/services/tjipBusyService';

@Component({
  components: {
    'app-menu': AppMenuVue,
    'app-header': AppHeaderVue,
    'app-body': AppBodyVue,
    'app-footer': AppFooterVue,
    'app-busy-overlay': AppBusyOverlayComponentVue
  }
})
export default class AppSiteLayout extends Vue {
  public get busy(): boolean {
    return !!tjipBusyService.promise().value;
  }
}
